var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8173 3.08693L9.80701 1.06748C9.36028 0.618714 8.7274 0.356934 8.09452 0.356934H4.93014C4.29726 0.356934 3.66438 0.618714 3.21765 1.06748L1.20733 3.08693C0.760597 3.53569 0.5 4.17144 0.5 4.8072V7.94856C0.5 8.58431 0.760597 9.22006 1.20733 9.66883L3.62716 12.0996C3.77607 12.2492 3.85052 12.4362 3.85052 12.6606V13.6329C3.85052 14.1939 4.29726 14.6426 4.85568 14.6426H8.05729C8.61572 14.6426 9.06245 14.1939 9.06245 13.6329V12.698C9.06245 12.511 9.13691 12.2866 9.28582 12.137L11.7801 9.66883C12.2268 9.22006 12.4874 8.58431 12.4874 7.94856V4.8072C12.5619 4.17144 12.3013 3.57309 11.8173 3.08693ZM9.99315 7.53719C9.99315 7.87376 9.88147 8.17294 9.6581 8.43472L8.69017 9.48184C8.35512 9.81842 8.28066 10.342 8.4668 10.7907L9.02522 12.1744H4.07389L4.63231 10.7907C4.81846 10.342 4.70677 9.85581 4.40895 9.48184L3.44102 8.43472C3.21765 8.21034 3.10596 7.87376 3.10596 7.53719V5.25596C3.10596 4.91939 3.21765 4.62021 3.44102 4.39583L4.52063 3.16172C4.78123 2.89994 5.11628 2.71296 5.48856 2.71296H7.61056C7.98284 2.71296 8.31789 2.86254 8.57849 3.16172L9.69533 4.39583C9.9187 4.62021 10.0304 4.95679 10.0304 5.29336V7.53719H9.99315Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.e7d09b3ab54b8a3237d677dc7781e484.svg";
export { ForwardRef as ReactComponent };